import { TableActionProps } from "../../types/table";
import { HouseForm } from "../../types/house-forms";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import React, { Fragment, useState } from "react";
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../components/ui/form";
import { Input } from "../../components/ui/input";
import { useEditHouseFormMutation } from "../../api/tenant/house-forms";
import { Button } from "../../components/ui/button";
import Loading from "../../components/global/loading";

function EditHouseForm({ row, onClose }: TableActionProps<HouseForm>) {
    const schema = z.object({
        name: z.string().min(2, {
            message: "Document name must be at least 2 characters.",
        }),
    });
    const form = useForm<z.infer<typeof schema>>({
        resolver: zodResolver(schema),
        defaultValues: {
            name: row.name,
        },
    });
    const [editHouseForm] = useEditHouseFormMutation();
    const [loading, setLoading] = useState<boolean>(false);

    async function handleSubmit(values: z.infer<typeof schema>) {
        setLoading(true);
        await editHouseForm({
            id: row.id,
            ...values,
        });

        onClose();

        setLoading(false);
    }

    return (
        <Loading
            loaded={!loading}
            child={
                <Fragment>
                    <DialogHeader>
                        <DialogTitle>Edit {row.name}</DialogTitle>
                    </DialogHeader>
                    <Form {...form}>
                        <form onSubmit={form.handleSubmit(handleSubmit)}>
                            <FormField
                                control={form.control}
                                name="name"
                                render={({ field }) => (
                                    <FormItem className="py-2">
                                        <FormLabel>
                                            Document name{" "}
                                            <span className="text-sm text-muted-foreground">*</span>
                                        </FormLabel>
                                        <FormControl>
                                            <Input {...field} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                            {form.formState.isValid && (
                                <DialogFooter className="mt-4">
                                    <Button type="submit">Save changes</Button>
                                </DialogFooter>
                            )}
                        </form>
                    </Form>
                </Fragment>
            }
        />
    );
}

export default EditHouseForm;
